import { getBuyerFooterClient } from 'dibs-buyer-layout/src/entries/index';
import { getEnvironment } from '../relayEnvironmnentProvider.es';
import { trackSocial, trackEvent } from 'dibs-tracking';

const $ = require('dibs-jquery-shim');

export const init = () => {
    const domNode = document.getElementById('js-footer');

    if (domNode) {
        const { updateUserState } = getBuyerFooterClient(getEnvironment(), domNode, {
            footer: { trackEvent, trackSocial }
        });

        $.subscribe('login:change', updateUserState);
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/core/footer.es.js